import {
    useCallback,
    useMemo,
} from 'react'
import clsx from 'clsx'
import Link from '@mui/material/Link'
import ArchiveIcon from '@mui/icons-material/Archive'
import UnarchiveIcon from '@mui/icons-material/Unarchive'

import {
    ListItemIcon, ListItemText,
} from '@mui/material'
import {
    useAppDispatch,
    useAppSelector,
} from 'app/store/hooks'
import {
    selectShowArchived,
    toggleShowArchived,
} from 'app/shared-components/TableControls/store'
import Tooltip from 'app/shared-components/Tooltip'

import useCommonStyles from '../common.styles'

import useStyles from './ShowArchived.styles'

type Props = {
    name: string,
    storeName?: string,
    onChange?: () => void,
    className?: {
        iconWrapper?: string,
        link?: string,
    },
    embeddedInDropdown?: boolean,
}

const defaultProps: Partial<Props> = {
    storeName: undefined,
    onChange: undefined,
    className: {},
    embeddedInDropdown: false,
}

const ShowArchived = ({
    name,
    storeName,
    onChange,
    className,
    embeddedInDropdown,
}: Props) => {
    const {
        classes,
    } = useStyles()
    const {
        classes: commonClasses,
    } = useCommonStyles()

    const dispatch = useAppDispatch()

    const showArchived = useAppSelector((state) => {
        return selectShowArchived(state, storeName || name)
    })

    const switchArchived = useCallback(() => {
        onChange?.()
        dispatch(toggleShowArchived(storeName || name))
    }, [
        dispatch,
        name,
        onChange,
        storeName,
    ])

    const title = useMemo(() => {
        return showArchived ? 'Hide Archived' : 'Show Archived'
    }, [showArchived])

    const IconComponent = useMemo(() => {
        return showArchived ? UnarchiveIcon : ArchiveIcon
    }, [showArchived])

    return (
        <Link
            data-testid="archive-btn"
            className={clsx(commonClasses.link, className.link, classes.link)}
            component="button"
            variant="body1"
            color="textSecondary"
            onClick={switchArchived}
        >
            {!embeddedInDropdown
                ? (
                    <Tooltip title={title}>
                        <div className={clsx(classes.iconWrapper, className.iconWrapper)}>
                            <IconComponent
                                className={classes.icon}
                            />
                        </div>
                    </Tooltip>
                ) : (
                    <>
                        <ListItemIcon>
                            <IconComponent
                                className={classes.icon}
                            />
                        </ListItemIcon>
                        <ListItemText primary={title} />
                    </>
                )}

        </Link>
    )
}

ShowArchived.defaultProps = defaultProps

export default ShowArchived
